export default {
  Actions: {
    FETCH_USER_SUGGESTIONS_SUCCESS: 'userSuggestions/FETCH_USER_SUGGESTIONS_SUCCESS',
    UPDATE_USER_SUGGESTION_SUCCESS: 'userSuggestions/UPDATE_USER_SUGGESTION_SUCCESS',
  },
  State: {
    USER_SUGGESTIONS_BY_SLUG: 'USER_SUGGESTIONS_BY_SLUG',
    USER_SUGGESTIONS_SLUGS_BY_DAY: 'USER_SUGGESTIONS_SLUGS_BY_DAY',
  },
};
